import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import CloseIcon from "@/components/icons/CloseIcon";

const TopHeader = () => {
  const { locale } = useRouter();

  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsIOS(
      userAgent.indexOf("iphone") > -1 ||
        userAgent.indexOf("ipad") > -1 ||
        userAgent.indexOf("ipod") > -1
    );
  }, []);

  const [active, setActive] = useState(
    typeof window !== "undefined" &&
      JSON.parse(window.sessionStorage.getItem("mobile-app"))
  );
  useEffect(() => {
    if (!active) {
      setActive(false);
      window.sessionStorage.setItem("mobile-app", "false");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`${
        !active ? "flex sm:hidden" : "hidden"
      }  bg-white py-2 px-3 items-center justify-between relative z-header`}
    >
      <div className="flex items-center justify-center w-full text-secondary-900">
        <p className="font-bold uppercase text-secondary-900 max-sm:text-xs">
          {locale === "en"
            ? "Download the app for the best offers"
            : "حمل التطبيق لتجربة شراء أفضل"}
        </p>
        <button
          aria-label="Mobile App Download button"
          className="mx-3 border border-secondary-900 text-secondary-900 px-3 py-1.5 rounded-md max-sm:text-xs"
          onClick={() =>
            window.open(
              isIOS
                ? "https://apps.apple.com/sa/app/abdulwahed-shopping-app/id1548762547"
                : "https://play.google.com/store/apps/details?id=com.abdulwahed&hl=en_US&gl=US"
            )
          } // need deep link
        >
          {locale === "en" ? "Install now" : "حمل التطبيق"}
        </button>
      </div>
      <CloseIcon
        onClick={() => {
          setActive(true);
          if (typeof window !== "undefined") {
            window.sessionStorage.setItem("mobile-app", "true");
          }
        }}
        className="text-white cursor-pointer size-4 max-sm:size-3"
      />
    </div>
  );
};

export default TopHeader;
